import { SCHEDULING_CONFLICTS_ABORT } from '../constants';
import config from '../config';

class AddNoShowCtrl {
  constructor(
    Restangular,
    Authentication,
    AlertService,
    ConfirmService,
    EventCollection,
    ShiftUtils,
    Utils,
    LeaveService,
    sdk,
    $state
  ) {
    'ngInject';

    Object.assign(this, {
      Restangular,
      Authentication,
      AlertService,
      ConfirmService,
      EventCollection,
      ShiftUtils,
      Utils,
      LeaveService,
      sdk,
      $state,
    });
    this.noShow = {};
    this.isManager = Authentication.user.isManager;
    this.shiftTo = [];
  }

  $onInit() {
    this.userId = this.data.user.id;
    this.noShow = this._getNoShowData();
    this.setNoShowsSummary();
  }

  async setNoShowsSummary() {
    this.noShowSummary = await this.LeaveService.getNoShowSummary(this.userId);
  }

  navigateToUserProfile() {
    const { user } = this.data;
    if (!user.deleted) {
      this.$state.go('users.profile', { userId: user.id });
    }
  }

  _handleError(error) {
    if (error && error !== SCHEDULING_CONFLICTS_ABORT) {
      this.error = this.Utils.getErrorMessages(error);
    }
  }

  async submit(noShow) {
    if (this.form.$invalid) {
      this.form.$setSubmitted();
      return;
    }

    if (
      noShow.shiftAction &&
      ['assign', 'offer'].includes(noShow.shiftAction) &&
      this.shiftTo.length
    ) {
      noShow.shiftRecipientId = this.shiftTo[0]?.id;
    }

    try {
      const checkRestBreakConflicts = config.CLOPENING_CONFLICT_ENABLED;

      const shifts = await this.ShiftUtils.performConflictingRequest({
        request: (ignoreConflicts) =>
          this.EventCollection.addNoShow(
            noShow,
            { ignoreConflicts, checkRestBreakConflicts },
            { ignoreGlobalErrorHandler: true }
          ),
        ignoreSuffix: 'assign this shift anyway',
      });

      this.EventCollection.undoingPossible = true;
      this.AlertService.success('Shift marked as no show');
      this.modal.close(shifts);
    } catch (e) {
      this._handleError(e);
      throw e; // for progress-button
    }
  }

  _getNoShowData() {
    return {
      shiftId: this.data.id,
      comment: '',
    };
  }
}

export default AddNoShowCtrl;
